
const Hotels = () => {
  const zones = [
    {
      id: "valencia-centro",
      name: "Valencia Centro",
      description: "Alojamientos algo más caros, pero es la mejor zona para alojarte si vienes a Valencia en tren/autobús. Si vas en coche va a ser dificil aparcar por aquí. Habrá una parada de autobús el día de la boda relativamente cerca de esta zona. Se puede ir a la parada andando o en metro.",
      image: "/valencia-centro.jpg",
      distances: {
        distanceVenue: "20 mins",
        distanceCityCenter: "0",
        distancePre: "30 mins",
        distancePost: "15 mins",
        distanceBus: "10-15 mins andando",
      },
    },
    {
      id: "ciudad-artes",
      name: "Ciudad de las Artes y las Ciencias",
      description: "Zona moderna y bonita junto al complejo arquitectónico más icónico de Valencia. Mejor opción que el centro si vienes en coche. Es también más económica.",
      image: "/ciudad-artes-y-ciencias-valencia2.jpg",
      distances: {
        distanceVenue: "30 mins",
        distanceCityCenter: "20 mins",
        distancePre: "30 mins",
        distancePost: "10-15 mins",
        distanceBus: "5-20 mins andando",
      },
    },
    {
      id: "alrededores",
      name: "Alrededores Valencia",
      description: "Alojamientos más económicos, pero necesitarás coche para moverte, y en estas zonas el Bus que va a la boda no hará paradas. Son zonas más apartadas y sin tanto encanto.",
      image: "/naranjas.jpg",
    },
  ];

  const hotels = [
    {
      name: "B&B HOTEL Valencia Alcàsser",
      location: "https://maps.app.goo.gl/saa1SVBP2nNVKMC36",
      locationDescription: "En alcásser, bastante a las afueras de Valencia y un poco aislado de todo.",
      link: "https://www.booking.com/Share-Lyl4Sdm",
      price: 37.5,
      persons: 2,
      description: "",
      zone: "alrededores",
      distances: {
        distanceVenue: "30 mins",
        distanceCityCenter: "30 mins",
        distancePre: "40 mins",
        distancePost: "20 mins",
        distanceBus: "20 mins",
      },
    },
    {
      name: "AC Hotel Valencia by Marriott",
      location: "https://maps.app.goo.gl/aetbVjFJ8MHA44Rx5",
      locationDescription: "Cerca del puerto de Valencia. Se puede llegar a la ciudad de las ciencias (donde hará parada el autobús) en transporte público.",
      link: "https://www.booking.com/Share-9eCq9tO",
      price: 75,
      persons: 2,
      description: "",
      zone: "alrededores",
      distances: {
        distanceVenue: "25 mins",
        distanceCityCenter: "20 mins",
        distancePre: "45 mins",
        distancePost: "12 mins",
        distanceBus: "20 mins andando",
      },
    },
    {
      name: "Soho Valencia Ruzafa",
      location: "https://maps.app.goo.gl/S7aGWu7shshgwsWC9",
      locationDescription: "En el centro, en el barrio de Ruzafa, una zona muy animada con muchos bares y restaurantes.",
      link: "https://www.booking.com/Share-WMoD2l7",
      price: 90,
      persons: 4,
      description: "En el centro de Valencia",
      zone: "valencia-centro",
      distances: {
        distanceVenue: "25 mins",
        distanceCityCenter: "10 mins andando",
        distancePre: "30 mins",
        distancePost: "15 mins",
        distanceBus: "20 mins andando",
      },
    },
    {
      name: "Vincci Mercat",
      location: "https://maps.app.goo.gl/oZfwJ6exdt3VZPVV8",
      locationDescription: "En el centro centro, pegado al mercado central.",
      link: "https://www.booking.com/Share-8dLfNbk",
      price: 160,
      persons: 4,
      description: "En el centro de Valencia",
      zone: "valencia-centro",
      distances: {
        distanceVenue: "25 mins",
        distanceCityCenter: "0",
        distancePre: "40 mins",
        distancePost: "15 mins",
        distanceBus: "15 mins andando",
      },
    },
    {
      name: "B48 Valencia Feria",
      location: "https://maps.app.goo.gl/bVc4axN178ujChv88",
      locationDescription: "En Valencia Feria, a la entrada de la ciudad. Una zona un poco alejada de todo, necesitarás el coche para moverte.",
      link: "https://www.booking.com/Share-korgu4",
      price: "70/30",
      persons: "2 y 4",
      description: "",
      zone: "alrededores",
      distances: {
        distanceVenue: "30 mins",
        distanceCityCenter: "20 mins",
        distancePre: "30 mins",
        distancePost: "20 mins",
        distanceBus: "15 mins",
      },
    },
    {
      name: "INNSiDE by Meliá Valencia Oceanic",
      location: "https://maps.app.goo.gl/DCaj1yFbDenHQDAA6",
      locationDescription: "Muy cerca de las artes y las ciencias.",
      link: "https://www.google.es/aclk?sa=L&ai=DChsSEwijlYm26fqTAxXQqP0FHdtwI5QYACICCAEQBxoCd2Y&co=1&ase=2&gclid=EAIaIQobChMIo5WJtun6kwMV0Kj9BR3bcCOUEAoYASABEgIx-fD_BwE&cid=CAASJuRoqmqAm_mrgzRCuZPNBk-zTnpipJEu0lUxhN_40VGTP-dHpeOI&cce=2&category=acrcp_v1_32&sig=AOD64_0EhUKy53OrqTdQTi3Ut8hTvdz_ug&nis=4&adurl",
      price: "100",
      persons: "2",
      description: "Muy cerca de las artes y las ciencias",
      zone: "ciudad-artes",
    },
    {
      name: "Hotel ILUNION Aqua 3",
      location: "https://maps.app.goo.gl/uCxQH9Mcmpn9oxvT8",
      locationDescription: "Muy cerca de las artes y las ciencias",
      link: "https://www.booking.com/Share-IILdkgl",
      price: "85",
      persons: "2",
      description: "Muy cerca de las artes y las ciencias.",
      zone: "ciudad-artes",
      distances: {
        distanceVenue: "20 mins",
        distanceCityCenter: "20 mins",
        distancePre: "45 mins",
        distancePost: "25 mins",
        distanceBus: "15 mins andando",
      },
    },
    {
      name: "Barceló Valencia",
      location: "https://maps.app.goo.gl/Hnt7d8K514ww3a1n6",
      locationDescription: "Muy cerca de las artes y las ciencias",
      link: "https://reservation.barcelo.com/?bep=CERES&hotel=7360&arrive=2026-09-11&depart=2026-09-13&rooms=1&store=es-es&theme=initialTheme&adult=2&child=0&marketprice=EUR&country=es&marketcampaign=ES&locale=es-es&currency=EUR&category=urban&campaignid=15626591194&fee=null&utm_medium=meta&sitetype=mapresults&mealplan=null&ectrans=1&partnerid=barcelo_hotels&utm_content=h7360&identifier=barcelo-google&utm_campaign=es_es_met_bm_bhg_alwayson-x-x-x-x-x-x_co&userlistid=&gclid=CjwKCAjwnZfPBhAGEiwAzg-VzPcinPfodLT181eMjTSfTUiF5iX75Qq6aHzGOQuZVudkUcbF064IlBoC8NgQAvD_BwE&ifdefaultdate=selected&dsclid=77734549782532096&utm_source=google",
      price: "72",
      persons: "2",
      description: "Muy cerca de las artes y las ciencias.",
      zone: "ciudad-artes",
      distances: {
        distanceVenue: "20 mins",
        distanceCityCenter: "20 mins",
        distancePre: "45 mins",
        distancePost: "25 mins",
        distanceBus: "9 mins andando",
      },
    },
    {
      name: "NH Valencia Las Artes",
      location: "https://maps.app.goo.gl/no3LDT2qASbAPBH98",
      locationDescription: "Muy cerca de las artes y las ciencias",
      link: "https://www.booking.com/Share-X0JnYw",
      price: "80",
      persons: "2",
      description: "Muy cerca de las artes y las ciencias.",
      zone: "ciudad-artes",
    },
    {
      name: "NH Valencia Las Ciencias",
      location: "https://maps.app.goo.gl/itiEBHzyqmh9RQJu5",
      locationDescription: "Muy cerca de las artes y las ciencias",
      link: "https://www.booking.com/Share-p5rwx7A",
      price: "80",
      persons: "2",
      description: "Muy cerca de las artes y las ciencias.",
      zone: "ciudad-artes",
    },
    {
      name: "HQ Arena Hotel",
      location: "https://maps.app.goo.gl/vnr6uNYy39NdFrpi8",
      locationDescription: "Un poco más alejado de las artes y las ciencias",
      link: "https://www.booking.com/Share-gVhxxD",
      price: "60",
      persons: "2",
      description: "Zona Arena. Un poco más alejado de las artes y las ciencias, pero con muy buena relación calidad/precio.",
      zone: "ciudad-artes",
      distances: {
        distanceVenue: "20 mins",
        distanceCityCenter: "20 mins",
        distancePre: "45 mins",
        distancePost: "25 mins",
        distanceBus: "17 mins andando",
      },
    },
    {
      name: "Arena Zone Hotel",
      location: "https://maps.app.goo.gl/ffhJnuamnbRg7Qfg8",
      locationDescription: "Un poco más alejado de las artes y las ciencias",
      link: "https://www.booking.com/Share-XrHl3v",
      price: "75",
      persons: "2",
      description: "Zona Arena. Un poco más alejado de las artes y las ciencias, pero con muy buena relación calidad/precio.",
      zone: "ciudad-artes",
      distances: {
        distanceVenue: "20 mins",
        distanceCityCenter: "20 mins",
        distancePre: "45 mins",
        distancePost: "25 mins",
        distanceBus: "17 mins andando",
      },
    },
    {
      name: "Holiday Inn Express - IHG",
      location: "https://maps.app.goo.gl/zFmdMHJUSxVATosz5",
      locationDescription: "Relativamente cerca de las artes y las ciencias",
      link: "https://www.booking.com/Share-To2qQ1",
      price: "80",
      persons: "2",
      description: "Muy bien de precio, y algo más cerca de las artes y las ciencias que los de la zona arena.",
      zone: "ciudad-artes",
      distances: {
        distanceVenue: "20 mins",
        distanceCityCenter: "20 mins",
        distancePre: "45 mins",
        distancePost: "25 mins",
        distanceBus: "17 mins andando",
      },
    },
    {
      name: "One shot Mercat",
      location: "https://maps.app.goo.gl/MDnqYRNbS7tC4tUy7",
      locationDescription: "En el centro, al lado del Mercado Central.",
      link: "https://www.oneshothotels.com/reservations/bookingstep1.html?idtokenprovider=100375980&checkin=11%2F09%2F2026&nights=2&lang=es&hsri=02040&adults=2&children=0&ages=0&babies=0&utm_source=hotelfinder&utm_medium=cpc&utm_campaign=hpa&hotel_campaign=23739356104&currency=EUR&rates=MzQwMzN8MTcyNTN8OTkyMTFiMHw0Mjk3fDI5Nzg3Nw&tracking=&utm_content=ES&UserDevice=desktop&clickorigin=NOT-RBM&date_type=selected&campaign_id=23739356104&googlesite=mapresults&tt_meta=gha&PPA1=FALSE&user_list_id=&clk_src=pm&prid=mirai_desktop_club&totalPrice=392.53&taxes=35.68&otherFees=0.00&gad_source=6&gad_campaignid=23729495514&gbraid=0AAAAA-LSkYQD5KLh4JjOLSf6VG9PpRqmR&gclid=CjwKCAjwnZfPBhAGEiwAzg-VzIKKmfoKgYfrjPRzufdqzub7rjV-ZI2E-Qo8fNVFklQwFjGRK03EFhoC-rgQAvD_BwE&step=1&home=https%3A%2F%2Fwww.oneshothotels.com%2F&parties=WyB7CiAgImFkdWx0cyIgOiAyLAogICJjaGlsZHJlbiIgOiBbIF0KfSBd&applyClubDiscount=true#url=true",
      price: "100",
      persons: "2",
      description: "",
      zone: "valencia-centro",
      distances: {
        distanceVenue: "20 mins",
        distanceCityCenter: "0",
        distancePre: "40 mins",
        distancePost: "15 mins",
        distanceBus: "15 mins andando",
      },
    },
    {
      name: "Hotel Beleret",
      location: "https://maps.app.goo.gl/MDnqYRNbS7tC4tUy7",
      locationDescription: "En Valencia Feria, a la entrada de la ciudad. Una zona un poco alejada de todo, necesitarás el coche para moverte.",
      link: "https://www.booking.com/Share-IqIehya",
      price: "60",
      persons: "1, 2 y 3",
      description: "",
      zone: "alrededores",
      distances: {
        distanceVenue: "30 mins",
        distanceCityCenter: "20 mins",
        distancePre: "30 mins",
        distancePost: "20 mins",
        distanceBus: "15 mins",
      },
    },
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <h3 className="text-xl font-semibold text-rose-600 text-center mb-4">Paradas del autobús el día de la boda (sábado) - Ida y vuelta </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
          <div className="flex flex-col items-center">
            <a href="https://maps.app.goo.gl/3S9KqVHko9d3ULqd7" target="_blank" rel="noopener noreferrer" className="cursor-pointer">
              <img src="/bus-stop-1.png" alt="Parada de autobús 1" className="rounded-lg shadow-md w-full object-cover" style={{ maxHeight: "300px" }} />
            </a>
            <a href="https://maps.app.goo.gl/3S9KqVHko9d3ULqd7" target="_blank" rel="noopener noreferrer" className="mt-2 text-rose-600 font-semibold text-sm hover:underline">
              Ciudad de las Artes y las Ciencias
            </a>
          </div>
          <div className="flex flex-col items-center">
            <a href="https://maps.app.goo.gl/NmhvsaDsR8uhhQVV8" target="_blank" rel="noopener noreferrer" className="cursor-pointer">
              <img src="/bus-stop-2.png" alt="Parada de autobús 2" className="rounded-lg shadow-md w-full object-cover" style={{ maxHeight: "300px" }} />
            </a>
            <a href="https://maps.app.goo.gl/NmhvsaDsR8uhhQVV8" target="_blank" rel="noopener noreferrer" className="mt-2 text-rose-600 font-semibold text-sm hover:underline">
              Plaza Puerta del Mar
            </a>
          </div>
        </div>

        <h2 className="font-great-vibes text-4xl text-center text-rose-600 mb-4">Alojamiento</h2>
        <p className="text-gray-700 text-center mb-8 max-w-2xl mx-auto">Os recomendamos alojaros en la Ciudad de las artes y las ciencias o por el centro. En estas dos zonas hará paradas el autobús que pondremos el día de la boda. Hemos añadido multiples hoteles, echadles un ojo pero os sugerimos que también miréis por vuestra cuenta en estas mismas zonas. Hemos incluido algunos hoteles más economicos en las zonas de los alrededores de Valencia, pero en esas zonas no parará el autobús.</p>

        <div className="space-y-10">
          {zones.map((zone) => {
            const zoneHotels = hotels
              .filter((h) => h.zone === zone.id)
              .sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
            if (zoneHotels.length === 0) return null;

            return (
              <div key={zone.id}>
                <div
                  className="relative rounded-xl overflow-hidden mb-4 shadow-lg"
                  style={{ minHeight: "180px" }}
                >
                  <img
                    src={zone.image}
                    alt={zone.name}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/20" />
                  <div className="relative z-10 p-6 sm:p-8 flex flex-col justify-end h-full" style={{ minHeight: "180px" }}>
                    <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2">{zone.name}</h3>
                    <p className="text-white/80 font-semibold text-sm sm:text-base max-w-lg">{zone.description}</p>
                  </div>
                </div>

                <div className="space-y-4">
                  {zoneHotels.map((hotel, index) => (
                    <a
                      key={index}
                      href={hotel.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex flex-col sm:flex-row bg-rose-50 rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden"
                    >
                      <div className="sm:w-40 w-full h-32 sm:h-auto bg-rose-200 flex items-center justify-center flex-shrink-0">
                        <svg className="w-10 h-10 text-rose-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                      </div>

                      <div className="flex-1 p-4 sm:p-5">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-3">
                          <h3 className="text-lg font-semibold text-rose-600">{hotel.name}</h3>
                          <span className="text-rose-700 font-bold text-lg whitespace-nowrap">
                            ~{hotel.price}€<span className="text-sm font-normal text-gray-500">/noche por persona</span>
                          </span>
                        </div>

                        {hotel.description && (
                          <p className="text-gray-600 text-sm mb-2">{hotel.description}</p>
                        )}

                        <div className="flex items-center gap-1 text-sm text-gray-500 mb-3">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          <span>{hotel.locationDescription}</span>
                          <span className="mx-1">·</span>
                          <span>{hotel.persons} {hotel.persons === 1 ? 'persona' : 'personas'}</span>
                        </div>

                        <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-500">
                          <span>📍 Venue: {(hotel.distances || zone.distances).distanceVenue}</span>
                          <span>🏙️ Centro: {(hotel.distances || zone.distances).distanceCityCenter}</span>
                          <span>🎉 Pre-boda: {(hotel.distances || zone.distances).distancePre}</span>
                          <span>☀️ Post-boda: {(hotel.distances || zone.distances).distancePost}</span>
                        </div>

                        <div
                          className="mt-3 inline-flex items-center gap-1 text-sm text-rose-500"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            window.open(hotel.location, '_blank');
                          }}
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                          </svg>
                          Ver en Google Maps
                        </div>
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            );
          })}

          {/* <div
            className="relative rounded-xl overflow-hidden mb-4 shadow-lg"
            style={{ minHeight: "180px" }}
          >
            <img
              src={zones[2].image}
              alt={zones[2].name}
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/20" />
            <div className="relative z-10 p-6 sm:p-8 flex flex-col justify-end h-full" style={{ minHeight: "180px" }}>
              <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2">{zones[2].name}</h3>
              <p className="text-white/80 font-semibold text-sm sm:text-base max-w-lg">{zones[2].description}</p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Hotels;
